import script from "./SharedBoxReportList.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedBoxReportList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/share.css?vue&type=style&index=0&id=6533f67d&scoped=true&lang=css&external"
import "./SharedBoxReportList.vue?vue&type=style&index=1&id=6533f67d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6533f67d"]])

export default __exports__